import { GLDistributionTable } from "../GLDistributionTable";
import { TimecardHistoryDetails } from "../TimecardHistoryDetails";
import { Checkbox, DataHeader, DataSource, Layout, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSettlementTimecardHistory extends Layout {
    checkboxIsVoid: Checkbox;
    dataheaderTimecardHistory: DataHeader;
    layoutGLDistributionTable: GLDistributionTable;
    layoutTimecardDetails: TimecardHistoryDetails;
    sourceDrsTimecardHist: DataSource;
    sourceJournalDriver: DataSource;
    tabGLDistribution: Tab;
    tabGeneral: Tab;
    tabTimecard: Tab;
    tabsetTImecard: Tabset;
    textboxCheckDate: Textbox;
    textboxCheckNumber: Textbox;
    textboxPayeeId: Textbox;
    textboxVoidDate: Textbox;
}
